import React from "react";
import {useHistory} from "react-router-dom";
import "./InvoiceCreate.scss";
import Swiper from "swiper";
import SwiperId from 'react-id-swiper';
import 'swiper/swiper-bundle.min.css'

function InvoiceCreate() {

    const history = useHistory()

    return(
        <div className="invoice-create-container">
            {/*Header*/}
            <div className="invoice-create-header">
                <span>ثبت فاکتور</span>
            </div>

            <div className="invoice-create-form">

                <div className="invoice-input">
                    <input type="text" name="" id="" placeholder="موبایل مشتری"/>
                    <i className="fa fa-mobile" style={{fontSize:24}}></i>
                </div>

                <div className="invoice-input">
                    <input type="text" name="" id="" placeholder="مبلغ فاکتور"/>
                    <i className="fa fa-credit-card" style={{fontSize:16}}></i>
                </div>
            </div>

            <div className="invoice-create-inquiry">
                <span>ثبت</span>
            </div>

            <div className="invoice-create-form">

                <div className="invoice-input">
                    <input type="text" name="" id="" placeholder="نام مشتری"/>
                    <i className="fa fa-user" style={{fontSize:16}}></i>
                </div>

                <div className="invoice-input">
                    <input type="text" name="" id="" placeholder="کد تخفیف"/>
                    <i className="fa fa-list"></i>
                </div>
            </div>



            <div className="invoice-create-price">
                <div className="invoice-create-price-off">
                    <span className="invoice-create-price-off-value">۲۵,۰۰۰ ریال</span>
                    <span>جمع تخفیف</span>
                </div>

                <div className="invoice-create-price-total">
                    <span>۱۵۰,۰۰۰ ریال</span>
                    <span>قابل پرداخت</span>
                </div>
            </div>

            <div className="invoice-create-inquiry">
                <span>صدور فاکتور</span>
            </div>

        </div>
    )
}

export {InvoiceCreate}
